module.exports = __webpack_public_path__ + "videos/cn_animate.a4472eb.mp4";